import { createContext } from 'react';
import { initialMenuItemState } from '../hooks/useMenu/reducer';
export const INITAL_MENU_CONTEXT_STATE = {
  menuItemsState: initialMenuItemState,
  setMenuItem: () => {},
  hideMenuItem: () => {},
  onMenuItemKeyDown: () => {}
};
export const MenuContext = /*#__PURE__*/createContext(INITAL_MENU_CONTEXT_STATE);
export const MenuContextProvider = MenuContext.Provider;